import React, { useState } from 'react';
import './StepQuestionnaire.css';
import './login.css'
import './CreateFirm.css'
import filingDistrictOptions from '../json/filing_district_options.json';
const BACKEND_API_URL = process.env.REACT_BACKEND_API_URL;
export function validateFirmForm(formData, step) {
    const errors = {};
  
    const validStates = [
      "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
      "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
      "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
      "VA", "WA", "WV", "WI", "WY", "DC"
    ];
  
    const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const zipRegex = /^\d{5}$/;

    if (!formData.name && step === 1) {
        errors.name = "Please enter your firm name.";
        return errors
      }

    if (!validStates.includes(formData.state.toUpperCase()) && step === 2) {
      errors.state = "Invalid state abbreviation.";
      return errors
    }
    if (!formData.street && step === 2) {
        errors.street = "Enter your street address.";
        return errors
      }
    if (!formData.city && step === 2) {
        errors.city = "Enter your city.";
        return errors
      }
    if (!formData.filing_district && step === 3) {
        errors.filing_district = "Choose your filing district.";
        return errors
      }
    if (!formData.division && step === 3) {
        errors.filing_district = "Enter your filing division.";
        return errors
      }
    if (!zipRegex.test(formData.zip_code) && step === 2) {
      errors.zip_code = "ZIP code must be 5 digits.";
      return errors
    }
  
    if (!emailRegex.test(formData.email) && step === 4) {
      errors.email = "Invalid email address.";
      return errors
    }
  
    if (!phoneRegex.test(formData.phone_number) && step === 4) {
      errors.phone_number = "Invalid phone number format.";
      return errors
    }
  
    if (formData.fax_number && !phoneRegex.test(formData.fax_number) && step === 4) {
      errors.fax_number = "Invalid fax number format.";
      return errors
    }
  
    return errors;
  }
  
const CreateFirm = () => {
  const [step, setStep] = useState(1);
  const totalSteps = 4;

  const [formData, setFormData] = useState({
    name: '',
    street: '',
    street2: '',
    city: '',
    state: '',
    zip_code: '',
    filing_district: '',
    division: '',
    phone_number: '',
    email: '',
    fax_number: '',
  });
  const [status, setStatus] = useState(null);
  const [modalType, setModalType] = useState(null);  // 'error' | 'success'
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const [showModal, setShowModal] = useState(false);

  const handleNext = () => {
    const errors = validateFirmForm(formData, step);
    if (Object.keys(errors).length > 0) {
        setStatus({ success: false, message: Object.values(errors).join(" ") });
        setModalType('error');
        setShowModal(true); // Show popup modal
        return;
      }
    if (step < totalSteps) setStep((prev) => prev + 1);
  };
  
  const handleBack = () => {
    if (step > 1) setStep((prev) => prev - 1);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFirmForm(formData, step);
    if (Object.keys(errors).length > 0) {
      setStatus({ success: false, message: Object.values(errors).join(" ") });
      setModalType('error');
      setShowModal(true)
      return;
    }
    
    try {
      const res = await fetch('https://backend.cisowskilaw.com/create-firm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus({ success: true, message: 'Firm created successfully!' });
        setModalType('success');
        setShowModal(true)
      } else if (data?.error?.name?.[0] === "firm with this name and filing district already exists.") {
        setStatus({ success: false, message: "Firm already exists" });
        setModalType('error');
        setShowModal(true)
      } else {
        setStatus({ success: false, message:  'Firm already exists' });
        setModalType('error');
        setShowModal(true)
      }
    } catch (err) {
      setStatus({ success: false, message: 'Something went wrong.' });
      setModalType('error');
      setShowModal(true)
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div className="main-content">
            <div className="question-text-container">
              <p className="question-text-firm-create">What is your firm's name?</p>
              <div><div className = "vertical-stack-intake">
              <input className ="text-input" type="text" name="name" placeholder = "Firm Name" value={formData.name} onChange={handleChange} />
              </div></div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="main-content">
            <div className="question-text-container">
              <p className="question-text-firm-create">What is your firm's address?</p>
            </div><div className = "vertical-stack-intake">
            <div className="realestate-grid-real">
                <input
                    className="street-input"
                    type="text"
                    name="street"
                    placeholder="Street"
                    value={formData.street} onChange={handleChange}
                />
                                <input
                    className="street-input"
                    type="text"
                    name="street2"
                    placeholder="Street Line 2"
                    value={formData.street2} onChange={handleChange}
                />
                <div className="bottom-row">
                    <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={formData.city} onChange={handleChange}
                    />
                    <input
                    type="text"
                    name="state"
                    placeholder="State"
                    value={formData.state} onChange={handleChange}
                    />
                    <input
                    type="text"
                    name="zip_code"
                    placeholder="Zip"
                    value={formData.zip_code} onChange={handleChange}
                    /></div>
                            </div></div>
        
          </div>
        );
      case 3:
        return (
          <div className="main-content">
            <div className="question-text-container">
              <p className="question-text-firm-create">What is your firm's filing district and division?</p>
              <div><div className = "vertical-stack-intake">
              <select className = "text-input" name="filing_district" value={formData.filing_district} onChange={handleChange} >
                <option value="">Select a district...</option>
                {filingDistrictOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <input className = "division-text-input" type="text" name ="division" placeholder="Division" value={formData.division} onChange={handleChange}/>
          </div></div></div></div>
        );
      case 4:
        return (
          <div className="main-content">
            <div className="question-text-container">
              <p className="question-text-firm-create">What is your firm's contact information?</p>
              <div className="vertical-stack-intake">
              <input type = "text" className = "text-input" name="phone_number" placeholder="Phone Number" value={formData.phone_number} onChange={handleChange}/>
              <input type = "text" className = "text-input" name="email" placeholder="Email" value={formData.email} onChange={handleChange}/>
              <input type = "text" className = "text-input" name="fax_number" placeholder="Fax Number (optional)" value={formData.fax_number} onChange={handleChange}/>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="step-questionnaire-container">
        {showModal && (
  <div className="modal-overlay">
    <div className={`modal-box ${modalType === 'success' ? 'success' : ''}`}>
      <p className="modal-message">{status?.message}</p>

      {modalType === 'success' && (
        <div>
          <a href="/login-firm" className="modal-link">Go to login page</a>
        </div>
      )}

      {modalType === 'error' && (
        <button className="modal-close-button" onClick={() => setShowModal(false)}>
          Close
        </button>
      )}
    </div>
  </div>
)}
      <h1 className="top-header">Firm Onboarding</h1>
      <div className="question-box">
        <div className="part-indicator">Step {step} of {totalSteps}</div>
        <div className="step-indicator">Firm Setup Progress</div>
        <h2 className="sub-header">
          {step === 1 && 'Step 1: Firm Name'}
          {step === 2 && 'Step 2: Address'}
          {step === 3 && 'Step 3: Filing District & Division'}
          {step === 4 && 'Step 4: Contact Information'}
        </h2>
        <svg className="progress-bar" height="6" width="100%">
          <rect width="100%" height="6" fill="#eee" />
          <rect width={`${(step / totalSteps) * 100}%`} height="6" fill="#007bff" />
        </svg>

        <div className="swoop-animation">{renderStep()}</div>
        <div className="nav-buttons">
          <button className="action-button left" onClick={handleBack} disabled={step === 1}>Back</button>
          {step === totalSteps ? (
            <button className="action-button right" onClick={handleSubmit}>Submit</button>
          ) : (
            <button className="action-button right" onClick={handleNext}>Next</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateFirm;